import React, { MouseEventHandler } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { IIcon } from '@core/Icons';

interface IProps extends IIcon {
    onIconClick: MouseEventHandler<HTMLButtonElement>;
}

const Component: React.FC<IProps> = ({ name, value, onIconClick }: IProps) => {
    const src = `public/img/svg/${value}`;
    return (
        <Button
            className="edit-device__icon-popper-btn"
            id={String(name)}
            key={name}
            onClick={onIconClick}
            onKeyDown={(e) => {
                const { key } = e;
                if (key === 'Enter') {
                    e.stopPropagation();
                    const target = e.target as HTMLElement;
                    target.click();
                }
            }}
        >
            <Box
                className="edit-device__icon-ico"
                component="img"
                alt="device icon"
                src={src}
            />
        </Button>
    );
};

const IconItemComponent = React.memo(Component);

export default IconItemComponent;
